<template>
  <div :class="['page-business', canEdit ? '' : 'disable-all']">
    <router-link to="/" class="btn-back"><span>Back to Dashboard</span></router-link>
    <h1 class="h2 mb-3">Business</h1>
    <div v-if="loading">{{ loadingMessage }}<b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon></div>
    <div v-else-if="saved">
      Successfully saved your info! <a href="/">Back to My Dashboard</a>
    </div>
    <div v-else>
      <b-form @submit="onSubmit" @reset="onReset" v-if="show && !saving">

        <b-card bg-variant="light" class="mb-3" header="Basic Info">
          <b-form-group
            label-cols-sm="3"
            label="OHI ID:"
            label-align-sm="right"
          >
            <b-form-input disabled v-model="form.ARVC_Account_ID_New__c" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Voting Area:"
            label-align-sm="right"
          >
            <b-form-input disabled v-model="form.FS_Voting_Area__c" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Business Name:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.Name" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Email Address:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.OrderApi__Account_Email__c" required></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Phone:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.Phone" required></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Website:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.Website" @blur="checkUrl" required></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="form.FS_Membership_Type__c && form.FS_Membership_Type__c.includes('Campground')"
            label-cols-sm="3"
            label="Number of Campgrounds:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.NCS__c" required></b-form-input>
          </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Physical Address">
          <b-form-group
            label-cols-sm="3"
            label="Street Address:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.ShippingStreet"></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="City:"
            label-align-sm="right"
          >
            <b-form-input id="nested-city" v-model="form.ShippingCity"></b-form-input>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="State / Province:"
              label-align-sm="right"
            >
            <multiselect v-model="form.ShippingStateCode" :multiple="false"
              :options="picklists.ShippingStateCode" label="value" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Zip / Postal:"
            label-align-sm="right"
          >
            <b-form-input id="nested-state"
              v-model="form.ShippingPostalCode"></b-form-input>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Country:"
              label-align-sm="right"
            >
            <multiselect v-model="form.ShippingCountryCode" :multiple="false"
              :options="picklists.ShippingCountryCode" label="value" track-by="value"></multiselect>
          </b-form-group>
        </b-card>

        <b-card bg-variant="light" class="mb-3" header="Mailing Address">
          <b-form-group
            label-cols-sm="3"
            label="Street Address:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.BillingStreet"></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="City:"
            label-align-sm="right"
          >
            <b-form-input id="nested-city" v-model="form.BillingCity"></b-form-input>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="State / Province:"
              label-align-sm="right"
            >
            <multiselect v-model="form.BillingStateCode" :multiple="false"
              :options="picklists.BillingStateCode" label="value" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Zip / Postal:"
            label-align-sm="right"
          >
            <b-form-input
              v-model="form.BillingPostalCode"></b-form-input>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Country:"
              label-align-sm="right"
            >
            <multiselect v-model="form.BillingCountryCode" :multiple="false"
              :options="picklists.BillingCountryCode" label="value" track-by="value"></multiselect>
          </b-form-group>
        </b-card>

        <b-card v-if="form.FS_Membership_Type__c &&
            (form.FS_Membership_Type__c.includes('Supplier') || form.FS_Membership_Type__c.includes('Benefit Provider'))"
            bg-variant="light" class="mb-3" header="Supplier Information">
          <b-form-group
            label-cols-sm="3"
            label="Supplier Logo:"
            label-align-sm="right"
          >
            <div class="images-container">
              <div v-if="form.FS_Supplier_Account_logo_URL__c">
                <img :src="form.FS_Supplier_Account_logo_URL__c" class="supplier-logo" /><br />
                <b-button class="action-button" @click="upload()" size="sm" variant="success">Replace Logo</b-button>
              </div>
              <div v-else>
                <b-button class="action-button" @click="upload()" size="sm" variant="success">Upload Logo</b-button>
              </div>
              <input type="file" class="hide-me-seymour" accept="image/*" ref="fileupload" @change="fileChange($event)" />
            </div>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Supplier Short Description:"
            label-align-sm="right"
          >
            <b-form-input v-model="form.FS_Supplier_Short_Description__c"></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Supplier Long Description:"
            label-align-sm="right"
          >
            <b-form-textarea v-model="form.Description" rows="3"></b-form-textarea >
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Supplier Primary Category"
              label-align-sm="right"
            >
            <multiselect v-model="form.FS_Supplier_Primary_Category__c" :multiple="false"
              :options="picklists.FS_Supplier_Primary_Category__c" label="label" track-by="value"></multiselect>
          </b-form-group>

          <b-form-group
              label-cols-sm="3"
              label="Supplier Additional Categories"
              label-align-sm="right"
              :description="canEdit ? 'Select all that apply.' : ''"
            >
            <multiselect v-model="form.FS_Supplier_Additional_Categories__c" :multiple="true"
              :options="picklists.FS_Supplier_Additional_Categories__c" label="label" track-by="value"></multiselect>
          </b-form-group>
        </b-card>

        <b-card v-if="canEdit && form.FS_Membership_Type__c &&
            (form.FS_Membership_Type__c.includes('MBP') || form.FS_Membership_Type__c.includes('Benefit Provider'))" bg-variant="light" class="mb-3" header="Staff Management">
          <template v-slot:header>
            <h6 class="mb-0 float-left" style="padding-top: 10px;">My Offers</h6>
            <b-button class="float-right" variant="outline-success" v-b-modal.add-offer>Add Offer</b-button>
          </template>
          <b-table class="mt-3" striped hover :items="offers" :fields="offerFields">
            <template v-slot:cell(start)="data">
              {{ data.item.start.substr(0, 10) }}
            </template>
            <template v-slot:cell(end)="data">
              {{ data.item.end.substr(0, 10) }}
            </template>
            <template v-slot:cell(actions)="data">
              <b-icon v-if="removingItem === data.item.id" icon="arrow-clockwise" animation="spin-pulse" font-scale="2"></b-icon>
              <a v-else @click="removedOffer(data.item.id)" style="margin-left: 10px;"><b-icon-trash /> Remove</a>
            </template>
          </b-table>
        </b-card>

        <div v-if="canEdit" class="text-right pb-5">
          <b-button type="submit" variant="primary" class="fr">Save Business Info</b-button>
        </div>

        <b-card v-if="canEdit" bg-variant="light" class="mb-3" header="Staff Management">
          <template v-slot:header>
            <h6 class="mb-0 float-left" style="padding-top: 10px;">Staff Management</h6>
            <b-button class="float-right" variant="outline-success" v-b-modal.add-staff>Add Staff Member</b-button>
          </template>
          <div class="explainer">
            <span>Staff Roles:</span><br />
            <ul>
              <li><strong>Administrator</strong>: Administrators have full access to the business within the
                portal (including editing information and managing staff members).</li>
              <li><strong>Employee</strong>: Employees can view most of the information in the portal but
                can't edit business information or manage staff members.</li>
            </ul>
          </div>
          <b-table class="mt-3" striped hover :items="items" :fields="fields">
            <template v-slot:cell(Roles)="data">
              <b-icon v-if="savingItem === data.item.Id" icon="arrow-clockwise" animation="spin-pulse" font-scale="2"></b-icon>
              <b-form-select v-else v-model="data.value" :options="options" @change="changedStaff(data.item.Id, data.value)"></b-form-select>
            </template>
            <template v-slot:cell(actions)="data">
              <b-icon v-if="removingItem === data.item.Id" icon="arrow-clockwise" animation="spin-pulse" font-scale="2"></b-icon>
              <a v-else @click="removedStaff(data.item.Id)" style="margin-left: 10px;"><b-icon-trash /> Remove</a>
            </template>
          </b-table>
        </b-card>
      </b-form>
      <b-card class="mt-3 dev-only" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
      </b-card>
    </div>
    <b-modal id="add-staff" centered >
      <template v-slot:modal-header="{}">
        <h5>Add Staff Member</h5>
      </template>
      <b-form-group
        label-cols-sm="3"
        label="First Name:"
        label-align-sm="right"
      >
        <b-form-input v-model="newStaff.FirstName"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Last Name:"
        label-align-sm="right"
      >
        <b-form-input v-model="newStaff.LastName"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Email:"
        label-align-sm="right"
      >
        <b-form-input v-model="newStaff.Email"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Role:"
        label-align-sm="right"
      >
        <b-form-select v-model="newStaff.Roles" :options="options"></b-form-select>
      </b-form-group>
      <template v-slot:modal-footer="{ cancel }">
        <b-button v-if="!savingStaff" size="sm"
          :variant="(newStaff.FirstName.length <= 2 || newStaff.LastName.length <= 2 || newStaff.Email.length) <= 5 ? 'secondary-outline' : 'success'"
          :disabled="(newStaff.FirstName.length <= 2 || newStaff.LastName.length <= 2 || newStaff.Email.length <= 5)" @click="addStaff()">
          Add
        </b-button>
        <b-button v-if="!savingStaff" size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <b-modal id="add-staff-confirm" centered >
      <template v-slot:modal-header="{}">
        <h5>Add Staff Member</h5>
      </template>
      Please allow 24-48 hours for the new staff member to be activated. They will receive an email when their account is ready that will walk them through setting up a password.
      <template v-slot:modal-footer="{ ok }">
        <b-button size="sm" variant="success" @click="ok()">
          Ok
        </b-button>
      </template>
    </b-modal>
    <b-modal id="add-offer" centered >
      <template v-slot:modal-header="{}">
        <h5>Add Offer</h5>
      </template>
      <b-form-group
        label-cols-sm="3"
        label="Offer Title:"
        label-align-sm="right"
      >
        <b-form-input v-model="newOffer.title"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Description:"
        label-align-sm="right"
      >
        <b-form-textarea v-model="newOffer.description" rows="3"></b-form-textarea>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Start:"
        label-align-sm="right"
      >
        <b-form-input type="date" v-model="newOffer.start"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="End:"
        label-align-sm="right"
      >
        <b-form-input type="date" v-model="newOffer.end"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Link Text:"
        label-align-sm="right"
      >
        <b-form-input v-model="newOffer.linkText"></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="3"
        label="Document:"
        label-align-sm="right"
      >
        <div class="images-container">
          <div v-if="newOffer.docLink">
            {{ newOffer.docLink.split('/')[newOffer.docLink.split('/').length - 1] }}<br />
            <b-button class="action-button" @click="uploadOffer()" size="sm" variant="success">Replace File</b-button>
          </div>
          <div v-else>
            <b-button class="action-button" @click="uploadOffer()" size="sm" variant="success">Upload File</b-button>
          </div>
          <input type="file" class="hide-me-seymour" accept="*/*" ref="fileofferupload" @change="fileOfferChange($event)" />
        </div>
      </b-form-group>
      <template v-slot:modal-footer="{ cancel }">
        <b-button v-if="!savingStaff" size="sm"
          :variant="(newOffer.title.length <= 2 || newOffer.description.length <= 2 || newOffer.start.length <= 5) ? 'secondary-outline' : 'success'"
          :disabled="(newOffer.title.length <= 2 || newOffer.description.length <= 2 || newOffer.start.length <= 5)" @click="addOffer()">
          Add
        </b-button>
        <b-button v-if="!savingStaff" size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <b-modal id="add-offer-confirm" centered >
      <template v-slot:modal-header="{}">
        <h5>Add Staff Member</h5>
      </template>
      Please allow 24-48 hours for the new staff member to be activated. They will receive an email when their account is ready that will walk them through setting up a password.
      <template v-slot:modal-footer="{ ok }">
        <b-button size="sm" variant="success" @click="ok()">
          Ok
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';

axios.defaults.withCredentials = true;
const server = process.env.VUE_APP_API_URL;

export default {
  name: 'Listing',
  components: {
    Multiselect,
  },
  props: {
    canEdit: Boolean,
  },
  data() {
    return {
      loading: true,
      saving: false,
      saved: false,
      loadingMessage: 'Loading... Please Wait...',
      slug: null,
      form: {},
      picklists: {},
      show: true,
      savingItem: null,
      removingItem: null,
      savingStaff: false,
      newStaff: {
        FirstName: '',
        LastName: '',
        Email: '',
        Roles: '',
      },
      savingOffer: null,
      removingOffer: null,
      isSavingOffer: false,
      newOffer: {
        title: '',
        description: '',
        start: '',
        end: '',
        linkText: '',
        docLink: '',
      },
      items: [],
      uploadOptions: {
        paramName: 'file',
      },
      options: [
        { value: '', text: 'Employee' },
        { value: 'Organization Administrator', text: 'Administrator' },
      ],
      fields: [
        {
          key: 'Name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'Email',
          label: 'Email',
          sortable: true,
        },
        {
          key: 'Roles',
          label: 'Role',
          sortable: true,
        },
        { key: 'actions', label: 'Actions' },
      ],
      offers: [],
      offerFields: [{
        key: 'title',
        label: 'Offer Title',
        sortable: true,
      },
      {
        key: 'start',
        label: 'Start',
        sortable: true,
      },
      {
        key: 'end',
        label: 'End',
        sortable: true,
      },
      { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    genForm() {
      const form = JSON.parse(JSON.stringify(this.form));
      Object.keys(form).forEach((key) => {
        if (form[key] && form[key][0] && form[key][0].value) {
          form[key] = form[key].map((x) => x.value);
        }
        if (form[key] && form[key].value) {
          form[key] = form[key].value;
        }
      });
      if (!form.FS_Supplier_Account_logo_URL__c || form.FS_Supplier_Account_logo_URL__c === '') {
        delete form.FS_Supplier_Account_logo_URL__c;
      }
      delete form.offers;
      return form;
    },
    upload() {
      this.$refs.fileupload.click();
    },
    uploadOffer() {
      this.$refs.fileofferupload.click();
    },
    async fileChange(evt) {
      console.log({ files: evt.target.files[0] });
      const formData = new FormData();
      formData.append('file', evt.target.files[0]);
      const imageMeta = await axios.post(`${server}/api/accounts/${this.form.Id}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const newurl = imageMeta.data.url;
      this.form.FS_Supplier_Account_logo_URL__c = imageMeta.data.url;
      console.log({
        url: newurl,
        title: '',
        order: 9999,
      });
    },
    async fileOfferChange(evt) {
      console.log({ files: evt.target.files[0] });
      const formData = new FormData();
      formData.append('file', evt.target.files[0]);
      const fileMeta = await axios.post(`${server}/api/accounts/${this.form.Id}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const newurl = fileMeta.data.url;
      this.newOffer.docLink = fileMeta.data.url;
      console.log({
        url: newurl,
        title: '',
        order: 9999,
      });
    },
    async onSubmit(evt) {
      this.saving = true;
      evt.preventDefault();
      window.scrollTo(0, 0);
      const payload = this.genForm();
      console.log({ payload });
      try {
        const saveResponse = await axios.post(`${server}/api/accounts/${this.$route.params.id}`, payload);
        this.saved = true;
        console.log({ saveResponse });
      } catch (saveError) {
        console.log({ saveError });
      }
    },
    async addStaff() {
      this.savingStaff = true;
      console.log('ADD', this.newStaff);
      const payload = {
        AccountId: this.$route.params.id,
        ...this.newStaff,
      };
      try {
        const rawItem = await axios.post(`${server}/api/staff`, payload);
        this.savingItem = null;
        this.items.push({
          Id: rawItem.data.saveResult.Id,
          Name: `${this.newStaff.FirstName} ${this.newStaff.LastName}`,
          Email: this.newStaff.Email,
          Roles: this.newStaff.Roles,
        });
        this.newStaff = {
          FirstName: '',
          LastName: '',
          Email: '',
          Roles: '',
        };
        console.log(rawItem.data.saveResult.Id);
        this.$bvModal.hide('add-staff');
        this.$bvModal.show('add-staff-confirm');
        this.savingStaff = false;
      } catch (err) {
        console.err(err);
      }
    },
    async addOffer() {
      this.isSavingOffer = true;
      console.log('ADD', this.newOffer);
      const payload = {
        sfId: this.$route.params.id,
        ...this.newOffer,
      };
      try {
        const rawItem = await axios.post(`${server}/api/offer`, payload);
        console.log({ rawItem });
        this.savingOffer = null;
        this.$bvModal.hide('add-offer');
        this.savingStaff = false;
        this.newOffer = {
          title: '',
          description: '',
          start: '',
          end: '',
          linkText: '',
          docLink: '',
        };
        this.offers.push({ id: rawItem.id, ...payload });
      } catch (err) {
        console.err(err);
      }
    },
    async changedStaff(contactId, rolesValue) {
      console.log('CHANGED', { contactId }, { rolesValue });
      this.savingItem = contactId;
      try {
        const rawItem = await axios.post(`${server}/api/staff/${contactId}`, { Roles: rolesValue });
        this.savingItem = null;
        this.items = this.items.map((c) => {
          if (c.Id === contactId) {
            c.Roles = rolesValue;
          }
          return c;
        });
        console.log(rawItem.data);
      } catch (err) {
        console.err(err);
      }
    },
    removedStaff(contactId) {
      console.log('REMOVED', { contactId });
      this.removingItem = contactId;
      const contact = this.items.find((c) => c.Id === contactId);
      this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this staff member from your business? They will no longer be able to use the Portal.', {
        title: `Remove ${contact.Name}`,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes, Remove',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then(async (value) => {
          if (value === true) {
            try {
              const rawItem = await axios.delete(`${server}/api/staff/${contactId}`);
              console.log(rawItem.data);
              this.items = this.items.filter((i) => i.Id !== contactId);
            } catch (err) {
              console.err(err);
            }
          }
          this.removingItem = null;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkUrl(evt) {
      if (!evt.target.value.startsWith('http')) {
        evt.target.value = `http://${evt.target.value}`;
      }
    },
    removedOffer(offerId) {
      console.log('REMOVED', { offerId });
      this.removingOffer = offerId;
      const offer = this.offers.find((c) => c.id === offerId);
      this.$bvModal.msgBoxConfirm('Are you sure you wish to remove this offer? It will no longer be showin the marketplace.', {
        title: `Remove ${offer.title}`,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Yes, Remove',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      })
        .then(async (value) => {
          if (value === true) {
            try {
              const rawItem = await axios.delete(`${server}/api/offer/${offerId}`);
              console.log(rawItem.data);
              this.offers = this.offers.filter((i) => i.id !== offerId);
            } catch (err) {
              console.err(err);
            }
          }
          this.removingOffer = null;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.Account_Org_Address__c = null;

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const rawItem = await axios.get(`${server}/api/accounts/${this.$route.params.id}`);
        if (rawItem.data.redirect) {
          window.location.href = rawItem.data.redirect;
          return;
        }
        console.log('Loading business', rawItem);
        this.picklists = rawItem.data.picklists;
        delete rawItem.data.picklists;
        this.items = rawItem.data.contacts.map((c) => ({
          Id: c.Id,
          Name: c.Contact.Name,
          Email: c.Contact.Email,
          Roles: c.Roles,
        }));
        this.offers = rawItem.data.offers;
        delete rawItem.data.contacts;
        this.form = rawItem.data;
        Object.keys(this.picklists).forEach((key) => {
          if (this.form[key]) {
            this.form[key] = this.picklists[key].filter((x) => this.form[key].includes(x.value));
          }
        });
        if (rawItem.data.IsCorp) {
          this.options.push({ value: 'Corporate Administrator', text: 'Corporate Administrator' });
        }
        this.loading = false;
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 200);
      } catch (err) {
        console.log({ getAccountError: err });
        this.loadingMessage = 'There was an issue pulling your business info. Please let us know so we can take a look!';
      }
    });
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
  .disable-all input, .disable-all .multiselect__tags, .disable-all .multiselect__single  {
    background: none !important;
    outline: none;
    border: none;
    pointer-events: none;
  }
  .disable-all .multiselect {
    pointer-events: none;
  }
  .disable-all .multiselect__select, .disable-all .multiselect__tag-icon {
    display: none;
  }
  .b-table a {
    cursor: pointer;
  }
</style>

<style lang="scss" scoped>

.supplier-logo {
  max-width: 90px;
  max-width: 90px;
  margin-bottom: 12px;
}

.hide-me-seymour {
  position: relative;
  top: -20000px;
}
</style>
